import React from "react"

export const PageWrapper = ({children}) => {
  return (
    <div className="resources-wrapper">
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/resources/components/PageWrapper.js